import axios from "axios";
import { del, get, post, put, API_URL } from "./api_helper";
import * as url from "./url_helper";
import authHeader from "helpers/authHeader";

// Gets the logged in user data from local session
const getLoggedInUser = () => {
    const user = localStorage.getItem("user");
    if (user) return JSON.parse(user);
    return null;
};

//is user is logged in
const isUserAuthenticated = () => {
    return getLoggedInUser() !== null;
};

// Register Method
const postFakeRegister = data => {
    return axios
        .post(url.POST_FAKE_REGISTER, data)
        .then(response => {
            if (response.status >= 200 || response.status <= 299) return response.data;
            throw response.data;
        })
        .catch(err => {
            let message;
            if (err.response && err.response.status) {
                switch (err.response.status) {
                    case 404:
                        message = "Sorry! the page you are looking for could not be found";
                        break;
                    case 500:
                        message =
                            "Sorry! something went wrong, please contact our support team";
                        break;
                    case 401:
                        message = "Invalid credentials";
                        break;
                    default:
                        message = err[1];
                        break;
                }
            }
            throw message;
        });
};

// Login Method
const postFakeLogin = data => post(url.POST_FAKE_LOGIN, data);

// postForgetPwd
const postFakeForgetPwd = data => post(url.POST_FAKE_PASSWORD_FORGET, data);

// Edit profile
const postJwtProfile = data => post(url.POST_EDIT_JWT_PROFILE, data);

const postFakeProfile = data => post(url.POST_EDIT_PROFILE, data);

// Register Method
const postJwtRegister = (url, data) => {
    return axios
        .post(url, data)
        .then(response => {
            if (response.status >= 200 || response.status <= 299) return response.data;
            throw response.data;
        })
        .catch(err => {
            var message;
            if (err.response && err.response.status) {
                switch (err.response.status) {
                    case 404:
                        message = "Sorry! the page you are looking for could not be found";
                        break;
                    case 500:
                        message =
                            "Sorry! something went wrong, please contact our support team";
                        break;
                    case 401:
                        message = "Invalid credentials";
                        break;
                    default:
                        message = err[1];
                        break;
                }
            }
            throw message;
        });
};

// Login MethodpostSocialLogin
const postJwtLogin = data => post(url.POST_FAKE_JWT_LOGIN, data);

// postForgetPwd
const postJwtForgetPwd = data => post(url.POST_FAKE_JWT_PASSWORD_FORGET, data);

// postSocialLogin
export const postSocialLogin = data => post(url.SOCIAL_LOGIN, data);

// get Products
export const getProducts = () => get(url.GET_PRODUCTS);


//GetAll State method
export const getState = () => post(url.GET_STATE, {}, { headers: authHeader() });

//GetAll Occupation method
export const getOccupation = () => post(url.GET_OCCUPATION, {}, { headers: authHeader() });

//GetAll Related_Person_Type
export const getRelatedPersonType = () => post(url.GET_RELATEDPERSONTYPE, {}, { headers: authHeader() });

//GetAll Education
export const getEducation = () => post(url.GET_EDUCATION, {}, { headers: authHeader() });

//GetAll OccupationDetails
export const getOccupationDetails = () => post(url.GET_OCCUPATIONDETAILS, {}, { headers: authHeader() });

//GetAll AssetDetails
export const getAssetDetails = () => post(url.GET_ASSETDETAILS, {}, { headers: authHeader() });

//GetAll OtherBankAccounts
export const getOtherBankAccounts = () => post(url.GET_OTHERBANKACCOUNTS, {}, { headers: authHeader() });

//GetAll AccountType
export const getAccountType = () => post(url.GET_ACCOUNTTYPE, {}, { headers: authHeader() });

//GetAll EntityTypes
export const getEntityType = () => post(url.GET_ENTITYTYPE, {}, { headers: authHeader() });

//GetAll Location
export const getLocation = () => post(url.GET_LOCATION, {}, { headers: authHeader() });

// GetByLocationId Branch
export const getBranch = (LocationId = "") =>
    get(`${url.GET_BRANCH}/${LocationId}`, { params: { LocationId } });

//GetAll POI
export const getPoi = () => post(url.GET_POI, {}, { headers: authHeader() });

//GetAll Reason To Become a Customer
export const getReasonToBecomeCustomer = () => post(url.GET_REASON_TO_BECOME_CUSTOMER, {}, { headers: authHeader() });

//Post-Get API Url
export const getAPIUrl = () => API_URL;

//Post-Get Otp
export const getOTPUrl = () => API_URL + url.POST_GETOTP;

//Post-Send Otp
export const verifyOTPUrl = () => API_URL + url.POST_VERIFYOTP;

//Post-Branch
export const branchUrl = () => API_URL + url.POST_BRANCH;

//Post-Registration
export const registrationUrl = () => API_URL + url.POST_REGISTRATION;

//Post-UpdatePersonalDetails
export const updatePersonalDetailsUrl = () => API_URL + url.POST_UPDATEPERSONALDETAILS;

//Post-RegistrationPOI
export const registrationPOIUrl = () => API_URL + url.POST_REGISTRATIONPOI;

//Post-UpdateFamilyDetails
export const familyDetilsUrl = () => API_URL + url.POST_FAMILYDETAILS;

//Post-UpdateDetailOfRelatedPerson
export const relatedPersonDetilsUrl = () => API_URL + url.POST_RELATEDPERSONDETAILS;

//Post-UpdateAdditionalDetails
export const additionalDetailsUrl = () => API_URL + url.POST_ADDITIONALDETAILS;

//Post-UpdateTechnoProducts
export const technoProductsUrl = () => API_URL + url.POST_TECHNOPRODUCTS;

//Post-UpdateNominationDetails
export const nominationDetailsUrl = () => API_URL + url.POST_NOMINATIONDETAILS;

//Post-SubmitAccount
export const submitAccountUrl = () => API_URL + url.POST_SUBMITACCOUNT;

//Post-StatusDetails
export const getAllCustomerAccountListUrl = () => API_URL + url.POST_GETALLCUSTOMERACCOUNTLIST;

//Delete-Account
export const deleteCustomerAccount = () => API_URL + url.POST_DELETECUSTOMERACCOUNT;

//Delete-Account Holder
export const deleteCustomerAccountHolder = () => API_URL + url.POST_DELETECUSTOMERACCOUNTHOLDER;

//Add-Account Holder
export const addCustomerAccountHolder = () => API_URL + url.POST_ADDCUSTOMERACCOUNTHOLDER;

//Post-Get Other Holder Details
export const getOtherHolderDetails = () => API_URL + url.POST_GETOTHERHOLDERSDETAILS;

//Post-UpdateAccountOperation
export const updateAccountOperationUrl = () => API_URL + url.POST_UPDATEACCOUNTOPERATION;

//Post-GetCustomerAdditionalDetails
export const getCustomerAdditionalDetailsUrl = () => API_URL + url.POST_GETCUSTOMERADDITIONALDETAILS;

//Post-GetCustomerNominationDetails
export const getCustomerNomineeDetailsUrl = () => API_URL + url.POST_GETCUSTOMERNOMINEEDETAILS;

//Post-GetCustomerTechnoProductsDetails
export const getCustomerTechnoProductDetailsUrl = () => API_URL + url.POST_GETCUSTOMERTECHNOPRODUCTDETAILS;

//Post-GetCustomerAccountOperationsDetails
export const getAccountOperationsDetailsUrl = () => API_URL + url.POST_GETACCOUNTOPERATIONSDETAILS;

//Post-CheckCustomerExists
export const getCheckCustomerExistsUrl = () => API_URL + url.POST_CHECKCUSTOMEREXISTS;

//Post-UpdateForm60
export const form60Url = () => API_URL + url.POST_FORM60;

//Post-GetDetailsAccount
export const createNewAccountUrl = () => API_URL + url.POST_CREATENEWACCOUNT;

//Post-GetCustomerAccountDetails
export const getCustomerAccountHolderList = () => API_URL + url.POST_GETCUSTOMERACCOUNTHOLDERLIST;

//Post-UpdateAccountHolderStatus
export const updateAccountHoldersStatusUrl = () => API_URL + url.POST_UPDATEACCOUNTHOLDERSSTATUS;

//Post-GetFirstAccountHolderDetails
export const getFirstAccountHolderDetailsUrl = () => API_URL + url.POST_GETFIRSTACCOUNTHOLDERDETAILS;

//Post-GetFDDetails
export const getFDDetailsUrl = () => API_URL + url.POST_GETFDDETAILS;

//Post-UpdateFDDetails
export const fdDetailsUrl = () => API_URL + url.POST_FDDETAILS;

//Post-GetRDDetails
export const getRDDetailsUrl = () => API_URL + url.POST_GETRDDETAILS;

//Post-UpdateFDDetails
export const rdDetailsUrl = () => API_URL + url.POST_RDDETAILS;

//Post-DeletePOI
export const deletePOIUrl = () => API_URL + url.POST_DELETEPOI;

//Post-GetAllBranchLoginCustomerList
export const getAllBranchLoginCustomerList = () => API_URL + url.POST_GETALLBRANCHLOGINCUSTOMERLIST;

//Post-GetRegistrationDetailsByRefNo
export const getRegistrationDetailsByRefNo = () => API_URL + url.POST_GETREGISTRATIONDETAILSBYREFNO;

//Post-GetRegistrationDetailsByRefNo
export const getCustomerDataByCustomerId = () => API_URL + url.POST_GETCUSTOMERDATABYCUSTOMERID;

//Post-checkBranchLogin
export const checkBranchLogin = () => API_URL + url.POST_CHECKBRANCHLOGIN;

// Post-GetCustomerProfileDetails
export const getCustomerProfileDetails = () => API_URL + url.POST_GETCUSTOMERPROFILEDETAILS;


// get Product detail
export const getProductDetail = id =>
    get(`${url.GET_PRODUCTS_DETAIL}/${id}`, { params: { id } });

// get Events
export const getEvents = () => get(url.GET_EVENTS);

// add Events
export const addNewEvent = event => post(url.ADD_NEW_EVENT, event);

// update Event
export const updateEvent = event => put(url.UPDATE_EVENT, event);

// delete Event
export const deleteEvent = event =>
    del(url.DELETE_EVENT, { headers: { event } });

// get Categories
export const getCategories = () => get(url.GET_CATEGORIES);

// get chats
export const getChats = () => get(url.GET_CHATS);

// get groups
export const getGroups = () => get(url.GET_GROUPS);

// get Contacts
export const getContacts = () => get(url.GET_CONTACTS);

// get messages
export const getMessages = (roomId = "") =>
    get(`${url.GET_MESSAGES}/${roomId}`, { params: { roomId } });

// post messages
export const addMessage = message => post(url.ADD_MESSAGE, message);

// get orders
export const getOrders = () => get(url.GET_ORDERS);

// add order
export const addNewOrder = order => post(url.ADD_NEW_ORDER, order);

// update order
export const updateOrder = order => put(url.UPDATE_ORDER, order);

// delete order
export const deleteOrder = order =>
    del(url.DELETE_ORDER, { headers: { order } });

// get cart data
export const getCartData = () => get(url.GET_CART_DATA);

// get customers
export const getCustomers = () => get(url.GET_CUSTOMERS);

// add CUSTOMER
export const addNewCustomer = customer => post(url.ADD_NEW_CUSTOMER, customer);

// update CUSTOMER
export const updateCustomer = customer => put(url.UPDATE_CUSTOMER, customer);

// delete CUSTOMER
export const deleteCustomer = customer =>
    del(url.DELETE_CUSTOMER, { headers: { customer } });

// get shops
export const getShops = () => get(url.GET_SHOPS);

// get wallet
export const getWallet = () => get(url.GET_WALLET);

// get crypto order
export const getCryptoOrder = () => get(url.GET_CRYPTO_ORDERS);

// get invoices
export const getInvoices = () => get(url.GET_INVOICES);

// get invoice details
export const getInvoiceDetail = id =>
    get(`${url.GET_INVOICE_DETAIL}/${id}`, { params: { id } });

// get project
export const getProjects = () => get(url.GET_PROJECTS);

// get project details
export const getProjectsDetails = id =>
    get(`${url.GET_PROJECT_DETAIL}/${id}`, { params: { id } });

// get tasks
export const getTasks = () => get(url.GET_TASKS);

// get contacts
export const getUsers = () => get(url.GET_USERS);

// add user
export const addNewUser = user => post(url.ADD_NEW_USER, user);

// update user
export const updateUser = user => put(url.UPDATE_USER, user);

// delete user
export const deleteUser = user => del(url.DELETE_USER, { headers: { user } });

/** PROJECT */
// add user
export const addNewProject = project => post(url.ADD_NEW_PROJECT, project);

// update user
export const updateProject = project => put(url.UPDATE_PROJECT, project);

// delete user
export const deleteProject = project =>
    del(url.DELETE_PROJECT, { headers: { project } });

export const getUserProfile = () => get(url.GET_USER_PROFILE);

// get inboxmail
export const getInboxMails = () => get(url.GET_INBOX_MAILS);

// add inboxmail
export const addNewInboxMail = inboxmail =>
    post(url.ADD_NEW_INBOX_MAIL, inboxmail);

// delete inboxmail
export const deleteInboxMail = inboxmail =>
    del(url.DELETE_INBOX_MAIL, { headers: { inboxmail } });

// get starredmail
export const getStarredMails = () => get(url.GET_STARRED_MAILS);

// get importantmail
export const getImportantMails = () => get(url.GET_IMPORTANT_MAILS);

// get sent mail
export const getSentMails = () => get(url.GET_SENT_MAILS);

// get trash mail
export const getTrashMails = () => get(url.GET_TRASH_MAILS);

// get starredmail
export const getDraftMails = () => get(url.GET_DRAFT_MAILS);

// get dashboard charts data
export const getWeeklyData = () => get(url.GET_WEEKLY_DATA);
export const getYearlyData = () => get(url.GET_YEARLY_DATA);
export const getMonthlyData = () => get(url.GET_MONTHLY_DATA);

export const topSellingData = month =>
    get(`${url.TOP_SELLING_DATA}/${month}`, { params: { month } });

export const getEarningChartsData = month =>
    get(`${url.GET_EARNING_DATA}/${month}`, { params: { month } });

const getProductComents = () => get(url.GET_PRODUCT_COMMENTS);

const onLikeComment = (commentId, productId) => {
    return post(`${url.ON_LIKNE_COMMENT}/${productId}/${commentId}`, {
        params: { commentId, productId },
    });
};
const onLikeReply = (commentId, productId, replyId) => {
    return post(`${url.ON_LIKNE_COMMENT}/${productId}/${commentId}/${replyId}`, {
        params: { commentId, productId, replyId },
    });
};

const onAddReply = (commentId, productId, replyText) => {
    return post(`${url.ON_ADD_REPLY}/${productId}/${commentId}`, {
        params: { commentId, productId, replyText },
    });
};

const onAddComment = (productId, commentText) => {
    return post(`${url.ON_ADD_COMMENT}/${productId}`, {
        params: { productId, commentText },
    });
};
//const url1 = "https://localhost:7010/api/State/GetAll";
//const getState = () => get(url1);





export {
    getLoggedInUser,
    isUserAuthenticated,
    postFakeRegister,
    postFakeLogin,
    postFakeProfile,
    postFakeForgetPwd,
    postJwtRegister,
    postJwtLogin,
    postJwtForgetPwd,
    postJwtProfile,
    getProductComents,
    onLikeComment,
    onLikeReply,
    onAddReply,
    onAddComment,
};
